import React from 'react';
import {Header, RequestList} from "../../components";
import {connect} from "react-redux";
import {withRouter} from "../../../../utils/services/with-router";
import {Flex, Tabs} from "antd";
import SentRequestList from "../../components/sentRequests/SentRequestList";

const SentBorrowRequestList = () => {
    return (
        <Flex vertical justify={"center"} gap={"large"}>
        <Header title={'درخواست ها'}/>
        <SentRequestList/>
    </Flex>
    );
};

export default connect(null, {})(
    withRouter(SentBorrowRequestList)
);
